var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnknownGenderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 62,
    height: 62
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31 62C13.8792 62 0 48.1208 0 31C0 13.8792 13.8792 0 31 0C48.1208 0 62 13.8792 62 31C62 48.1208 48.1208 62 31 62Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31 62C13.8792 62 0 48.1208 0 31C0 13.8792 13.8792 0 31 0C48.1208 0 62 13.8792 62 31C62 48.1208 48.1208 62 31 62Z",
    fill: "#E3E5EF"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.8 32.5488V25.5955L24.379 26.1745C25.7148 27.5103 28 26.5638 28 24.6746C28 24.3925 27.9446 24.1173 27.8388 23.8623C27.6145 23.3213 27.8579 23.6535 21.4001 17.1956L15.4211 23.1746C15.0236 23.5721 14.8001 24.1114 14.8001 24.6746C14.8001 26.5621 17.0835 27.5121 18.4211 26.1745L19.0001 25.5955V32.5488C15.5305 33.5815 13 36.7945 13 40.6C13 45.2395 16.7605 49 21.4 49C26.0395 49 29.8 45.2395 29.8 40.6C29.8 36.7945 27.2695 33.5815 23.8 32.5488ZM21.4 44.2C19.4118 44.2 17.8 42.5882 17.8 40.6C17.8 38.6118 19.4118 37 21.4 37C23.3883 37 25 38.6118 25 40.6C25 42.5882 23.3883 44.2 21.4 44.2Z",
    fill: "#99AAE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0002 29.4512C46.4697 28.4185 49.0002 25.2055 49.0002 21.4C49.0002 16.7605 45.2396 13 40.6001 13C35.9606 13 32.2002 16.7605 32.2002 21.4C32.2002 25.2055 34.7307 28.4185 38.2002 29.4513V35.2H33.4001V40H38.2002V44.8H43.0002V40H47.8002V35.2H43.0002V29.4512ZM40.6001 25C38.6119 25 37.0001 23.3883 37.0001 21.4C37.0001 19.4118 38.6119 17.8 40.6001 17.8C42.5884 17.8 44.2001 19.4118 44.2001 21.4C44.2001 23.3883 42.5884 25 40.6001 25Z",
    fill: "#F1B287"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 62,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(13 13)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnknownGenderIcon);
export default __webpack_public_path__ + "static/media/unknownGenderIcon.9e78452752c45505c9cba8c0c92978e5.svg";
export { ForwardRef as ReactComponent };